var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", { staticClass: "mb-2" }, [
      _c("b", [_vm._v(_vm._s(_vm.label))])
    ]),
    _c("br"),
    _vm._v(" "),
    _c("div", [
      _vm.uploadPercentage
        ? _c("div", { staticClass: "progress mb-2" }, [
            _c("div", {
              staticClass: "progress-bar progress-bar-striped bg-success",
              style: { width: _vm.uploadPercentage + "%" },
              attrs: {
                role: "progressbar",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          multiple: !_vm.noMultiple,
          name: "bijlagen",
          accept: _vm.acceptedFileTypes
        },
        on: {
          change: function($event) {
            return _vm.onFileSelected($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-outline-dark",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$refs.fileInput.click()
            }
          }
        },
        [
          _c("font-awesome-icon", { attrs: { icon: ["far", "folder-open"] } }),
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.noMultiple ? "Kies een bestand..." : "Kies bestanden..."
              ) +
              "\n    "
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.bestanden.length > 0
        ? _c(
            "div",
            { staticClass: "container mt-4" },
            _vm._l(_vm.bestanden, function(bestand, bestandIndex) {
              return _c(
                "ul",
                {
                  key: bestandIndex,
                  staticClass: "list-group list-group-flush text-left mb-2"
                },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "list-group-item text-center p-0 border border-primary bg-gradient-light rounded"
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(bestand.name) + "\n          "
                      ),
                      _c("delete-button", {
                        on: {
                          click: function($event) {
                            return _vm.deleteFile(bestandIndex)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }